import React from "react";
import { Link } from "react-router-dom";
import { Card, Dropdown, Row } from "react-bootstrap";
import ReactApexCharts from "react-apexcharts";

const Localities = (props: any) => {
  let data: any = props.data;
  let quantities: [] = data.map((item: any) => item.followersCount);
  let names: [] = data.map((item: any) => item.localityName);

  //render
  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h4 className="header-title">Locality Followers</h4>
        {/* <Dropdown>
          <Dropdown.Toggle as="a" className="arrow-none card-drop">
            <i className="ri-more-2-fill" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item>Refresh Report</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
      </Card.Header>

      <Card.Body className="pt-0">
        <Row>
          {/* Render the Pie Chart using ApexCharts */}
          <ReactApexCharts
            className="apex-charts"
            height={350}
            type="pie"
            series={quantities}  
            options={{
              labels: names,  // Use the extracted names for chart labels
              legend: {
                show: true,
                position: "bottom"
              },
              colors: ["#00AB55", "#2D99FF", "#FFE700", "#826AF9"]  
            }}
          />

          {/* Render the Table with the dynamic data */}
          <div className="table-responsive mt-3">
            <table className="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Locality</th>
                  <th>Followers</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item:any, index:number ) => (
                  <tr key={index}>
                    <td>
                      <Link to="#" className="text-muted">
                        {item.localityName}
                      </Link>
                    </td>
                    <td>{item.followersCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Localities;
